export default "__VITE_ASSET__JXF17flx__"